// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PortfolioDashboard/navigationPages/Component page/AssetClass/assetClass.css
// module id = 901
// module chunks = 0